import { Button } from 'antd';
import { UnderlineOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const Underline = ({ editor, showLabel = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${editor.isActive('underline') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<UnderlineOutlined className="text-gray-800 text-xs" />}
      onClick={() => editor.chain().focus().toggleUnderline().run()}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="UNDERLINE" defaultMessage="Underline" />
        </div>
      )}
    </Button>
  );
};

export default Underline;
